/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardContent } from '../../models/card-content';
import { CardContentApiRespModel } from '../../models/card-content-api-resp-model';

export interface ApiMasterCardContentAddPost$Params {
      body?: CardContent
}

export function apiMasterCardContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterCardContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CardContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCardContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CardContentApiRespModel>;
    })
  );
}

apiMasterCardContentAddPost.PATH = '/api/Master/CardContent/Add';
